export interface AppRoute {
  url: string;
}

export const ROUTES = {
  home: { url: "/" },
  howItWorks: { url: "/how-it-works" },
  pricing: { url: "/pricing" },
  solutions: { url: "/solutions" },
  solutionsBanks: { url: "/solutions/banks" },
  solutionsLenders: { url: "/solutions/lenders" },
  solutionsEmployers: { url: "/solutions/employers" },
  solutionsInsurance: { url: "/solutions/insurance" },
  solutionsGovernment: { url: "/solutions/government" },
  solutionsCollections: { url: "/solutions/collections" },
  developers: { url: "/developers" },
  resources: { url: "/resources" },
  faq: { url: "/faq" },
  about: { url: "/about" },
  security: { url: "/security" },
  contact: { url: "/contact" },
  bookACall: { url: "/book-a-call" },
  feedback: { url: "/feedback" },
  privacy: { url: "/privacy" },
  terms: { url: "/terms" },
  account: { url: "/account" },
  accountLogin: { url: "/account/login" },
  accountRegister: { url: "/account/register" },
  dashboardBulkVerification: { url: "/dashboard/deceased-bulk-verification" },
  dashboardInstantVerification: { url: "/dashboard/instant-verification" },
  dashboardWallet: { url: "/dashboard/wallet" },
  admin: { url: "/admin" },
  adminFiles: { url: "/admin/files" }
} as const satisfies Record<string, AppRoute>;
